export * from './kng-loader.interface';
